import React, { useState, useEffect } from "react";
import { Table, Button, Spin } from "antd";
import "./IpManagement.scss";
import Banner from "../../components/Banner/Banner";
import invite from "../../../Assets/svg/inviteButton.svg";
import add from "../../../Assets/svg/addButton.svg";
import deleteIcon from "../../../Assets/svg/table-action-delete.svg";
import editIcon from "../../../Assets/svg/table-action-edit.svg";
import previewIcon from "../../../Assets/svg/table-action-preview.svg";
import numberOfMembers from "../../../Assets/svg/numberOfMembers.svg";
import { get } from "../../../services/authService";
import DeleteComponent from "../../components/DeleteComponent/DeleteComponent";
import PreviewIp from "./PreviewIp";
import EditIp from "./EditIp";
import AddNewIp from "./AddNewIp";
import TableFilters from "./TableFilters";
import axios from "axios";
import MessagePopUp from "../../components/Messages/MessagePopUp";

const IpManagement = () => {
  const [showAddIpModal, setShowAddIpModal] = useState(false);
  const [showEditIpModal, setShowEditIpModal] = useState(false);
  const [showPreviewIpModal, setShowPreviewIpModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const workspaceId = localStorage.getItem("currentContractId");
  const [loading, setLoading] = useState(false);
  const [ips, setIPs] = useState([]);
  const [search, setSearch] = useState("");
  const [totalIPs, setTotalIPs] = useState(0);
  const [filters, setFilters] = useState({
    search: "",
    CityId: "",
    CountryId: "",
  });


  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const handleToggleEditIpModal = (record) => {
    setSelectedRowData(record);
    setShowEditIpModal(!showEditIpModal);
  };

  const handleTogglePreviewIpModal = (record) => {
    setSelectedRowData(record);
    setShowPreviewIpModal(!showPreviewIpModal);
  };

  const handleToggleAddIpModal = () => {
    setShowAddIpModal(!showAddIpModal);
  };

  const fetchIP = async (current, pageSize) => {
    try {
      setLoading(true);
      const params = {
        contractId: workspaceId,
        search: filters.search,
        CityId: filters.CityId,
        CountryId: filters.CountryId,
        pageNumber: current,
        pageSize: pageSize
      }

      const response = await get(
        `/api/ImplementingPartner/getAllImplementingPartners`, params
      );

      const data = response.data.map((item) => ({
        key: item?.id,
        id: item?.id,
        name: item?.name,
        cities: item?.cities?.map((city) => city.name).join(", "), 
        country: item?.cities?.[0]?.country?.stateName, 
      }));

      setIPs(data);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current: response.metaData.pageNumber,
        pageSize: response.metaData.pageSize,
        total: response.metaData.totalItemCount,
      }));
      setTotalIPs(response.metaData.totalItemCount);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching IPs:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIP(pagination.current, pagination.pageSize);
  }, [filters, pagination.current, pagination.pageSize]);

  const columns = [
    {
      title: <span className="styledTitle">IP Name</span>,
      dataIndex: "name",
      key: "name",
      render: (text) => <span className="styledDataIndex">{text}</span>,
    },
    {
      title: <span className="styledTitle">Governorate/State</span>,
      dataIndex: "cities",
      key: "cities",
      render: (text) => <span className="styledDataIndex">{text}</span>,
    },
    {
      title: <span className="styledTitle">Country</span>,
      dataIndex: "country",
      key: "country",
      render: (text) => <span className="styledDataIndex">{text}</span>,
    },
    {
      key: "action",
      fixed: isLargeScreen && ips.length > 0 ? "right" : undefined,
      render: (text, record) => (
        <div className="actionDiv">
          <img
            src={previewIcon}
            onClick={() => handleTogglePreviewIpModal(record)}
            style={{ cursor: "pointer" }}
            alt="Preview"
          />
          <img
            src={editIcon}
            onClick={() => handleToggleEditIpModal(record)}
            style={{ cursor: "pointer" }}
            alt="Edit"
          />
          <img
            src={deleteIcon}
            style={{ cursor: "pointer" }}
            onClick={() => handleDeleteIP(record.id)}
            alt="Delete"
          />
        </div>
      ),
    },
  ];

  const handleTableChange = (pagination) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
  };

  const [checkStrictly, setCheckStrictly] = useState(false);

  const handleAddEditIp = async () => {
    try {
      setLoading(true);
      await fetchIP(pagination.current, pagination.pageSize);
    } catch (error) {
      console.error("Error adding project:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteIP = (id) => {
    setSelectedRowData({ id }); // Store the ID of the member to be deleted
    setShowDeleteModal(true); // Show the delete confirmation modal
  };

  const handleConfirmDelete = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const response = await axios({
        method: "delete",
        url: "https://stagingapi.tpmready.com/api/ImplementingPartner/deleteImplementingPartners?includeIsDeleted=false",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json-patch+json", // Ensure this matches backend
        },
        data: [
          {
            id: selectedRowData.id,
            isDeleted: true, // Make sure you're marking it as deleted
          },
        ],
      });

      // After successful deletion, refetch the users list
      await fetchIP(pagination.current, pagination.pageSize);
    } catch (error) {
      console.error("Error deleting member:", error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false); // Close the delete confirmation modal
    }
  };

  return (
    <div>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <Banner text="IP Management"></Banner>
      <div className="mainDivUserManagement">
        <div className="userManagementHeader">
          <div className="userManagementHeaderFirst">
            <span className="userManagementHeaderText">Linked IPs</span>
            <div className="numberOfMembers">
              <img src={numberOfMembers} alt="Members" />
              <span style={{ marginLeft: "7px" }}>{loading ? <Spin size="small" /> : totalIPs}</span>
            </div>
          </div>
          <div className="userManagementHeaderSecond">
            <Button className="addButtonTPM" onClick={handleToggleAddIpModal}>
              <img src={add} alt="Add" />
              Add new IP
            </Button>
          </div>
        </div>
        <div className="membersText">
          Here’s the list of the IPs in your workspace
        </div>
        <TableFilters filters={filters} setFilters={setFilters} setPagination={setPagination}/>
        <div style={{ overflowX: "auto", marginTop: "20px" }}>
          <Table
            rowSelection={{ ...rowSelection, checkStrictly }}
            dataSource={ips}
            columns={columns}
            className="tableTPM"
            loading={loading}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
            }}
            onChange={handleTableChange} // Add this line
          />
        </div>
      </div>
      <AddNewIp
        visible={showAddIpModal}
        onClose={handleToggleAddIpModal}
        onSubmit={handleAddEditIp}
        setMessage={setMessage}
      />
      <EditIp
        visible={showEditIpModal}
        onClose={handleToggleEditIpModal}
        record={selectedRowData}
        onSubmit={handleAddEditIp} 
        setMessage={setMessage}
      />
      <PreviewIp
        visible={showPreviewIpModal}
        onClose={handleTogglePreviewIpModal}
        record={selectedRowData}
      />
      <DeleteComponent
        visible={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        text={"You're about to delete this IP. This action can’t be undone."}
        header={"Delete IP"}
      />
    </div>
  );
};

export default IpManagement;
